// removed by extract-text-webpack-plugin
module.exports = {"container":"_2cd0yIhw8EsATr3CVY8JSH","applicationSection":"_2kKxc0iM6HD4ign60A4_3w","applicationMenuSection":"_1wCZDRkBE6E_OIZPRfV1BF"};


//////////////////
// WEBPACK FOOTER
// ./src/DomainApplicationView/DomainApplicationView.css
// module id = 203
// module chunks = 0